import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ResetPasswordPage } from "@/features/auth/reset-password-page";

/**
 * メールのリンクから開くパスワード再設定ページ。
 *
 * **`_authenticated` の外の公開ルート**（/terms・/privacy と同階層）。
 * パスワードを忘れた人が使うので、認証ガードを付けたら本末転倒になる。
 *
 * `token` を optional にしてあるのは、ページ側が読み取り直後に URL から
 * 除去する（`search: {}` で replace する）ため —— 必須にすると、除去した瞬間に
 * SearchParamError で落ちる。
 */
const searchSchema = z.object({
  token: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/reset-password")({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { token } = Route.useSearch();
  return <ResetPasswordPage token={token} />;
}
